import { Toast } from 'ngx-toastr';
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ellf-toast',
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        /* background-color: #ff69b4; */
        position: relative;
        overflow: hidden;
        /* margin: 0 0 6px; */
        /* padding: 10px 10px 10px 10px; */
        /* width: 300px; */
        /* border-radius: 3px 3px 3px 3px; */
        /* color: #ffffff; */
        /* pointer-events: all; */
        /* cursor: pointer; */
      }
      /* .btn-pink {
        -webkit-backface-visibility: hidden;
        -webkit-transform: translateZ(0);
      } */
    `,
  ],
  template: `
    <div
      class="d-flex flex-grow-1"
      [style.display]="state() === 'inactive' ? 'none' : ''"
      >
      <div class="flex-grow-1 d-flex flex-column justify-content-center">
        @if (title()) {
          <div
            [class]="options().titleClass"
            [attr.aria-label]="title()"
            >
            {{ title() }}
          </div>
        }
        @if (message() && options().enableHtml) {
          <div
            role="alert"
            aria-live="polite"
            [class]="options().messageClass"
            [innerHTML]="message()"
          ></div>
        }
        @if (message() && !options().enableHtml) {
          <div
            role="alert"
            aria-live="polite"
            [class]="options().messageClass"
            [attr.aria-label]="message()"
            >
            {{ message() }}
          </div>
        }
      </div>
      <div class="text-right d-flex ">
        @if (options().closeButton) {
          <span
            class="feather cursor-pointer icon-x"
            (click)="remove()"
          ></span>
        }
      </div>
    </div>
    @if (options().progressBar) {
      <div>
        <div class="toast-progress" [style.width]="width() + '%'"></div>
      </div>
    }
    `,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ToastComponent extends Toast {}
